export default {
	deviceList: {
		title: 'Device List',
		total: 'Total Devices',
		running: 'Running',
		stopped: 'Stopped',
		offline: 'Offline',
		lowAlarm: 'Low Alarm',
		mediumAlarm: 'Medium Alarm',
		severeAlarm: 'Severe Alarm',
		unit: 'units',
		noData: 'No Data',
		deviceName: 'Device Name',
		status: {
			running: 'Running',
			stopped: 'Stopped',
			offline: 'Offline'
		},
		warnLevel: {
			normal: 'Normal',
			low: 'Low',
			medium: 'Medium',
			severe: 'Severe'
		},
		labels: {
			warnLevel: 'Alarm Level',
			runDuration: 'Current Run Duration',
			stopDuration: 'Current Stop Duration',
			offlineDuration: 'Offline Duration',
			deviceType: 'Device Type'
		},
		imageError: 'Image Load Failed',
		filter: {
			total: 'total',
			status: {
				running: 'RUN',
				stopped: 'STOP',
				offline: 'OFFLINE'
			}
		},
		sensorGroup: 'Sensor Group',
		configDeviceModel: 'Configure Device Model',
		sensorManager: 'Sensor Manager',
		selectAll: 'Select All',
		clearAll: 'Clear All',
		maxSensorsTip: 'Maximum 20 sensors displayed',
		editGroup: 'Edit Group',
		addGroup: 'Add Group',
		groupName: 'Group Name',
		groupNameRequired: 'Please enter group name',
		groupNamePlaceholder: 'Please enter group name',
		selectSensor: 'Select Sensor',
		searchSensor: 'Search Sensor',
		noOptionalSensors: 'No available sensors',
		onlineStatus: 'Online',
		offlineStatus: 'Offline',
		alarmInfoSuffix: 'Alarm Info',
		messages: {
			updateSuccess: 'Updated successfully',
			updateFailed: 'Update failed',
			addSuccess: 'Added successfully',
			addFailed: 'Add failed',
			deleteSuccess: 'Deleted successfully',
			deleteFailed: 'Delete failed',
			save3DSuccess: '3D position saved successfully',
			save3DEmpty: 'No 3D position data to save',
			savePointSuccess: 'Position saved successfully',
			set3DModelSuccess: 'Device 3D model set successfully',
			set25DSuccess: 'Device 2.5D image set successfully',
			groupNameRequired: 'Please enter group name',
			sensorRequired: 'Please select at least one sensor',
			deleteGroupConfirm: 'Confirm delete this group? Sensors in the group will be ungrouped.',
			deleteGroupSimpleConfirm: 'Confirm delete this group?',
			confirmTitle: 'Tip',
			confirm: 'Confirm',
			cancel: 'Cancel'
		},
		warnStatusText: {
			normal: 'Normal',
			general: 'General',
			medium: 'Medium',
			severe: 'Severe'
		}
	},
	deviceDetails: {
		back: 'Back',
		featureUpdateTime: 'Feature Data Update Time',
		deviceParams: 'Device Parameters',
		deviceInfo: 'Device Information',
		deviceNumber: 'Device Number',
		deviceNameLabel: 'Device Name',
		type: 'Type',
		orgName: 'Factory',
		healthDegree: 'Device Health',
		alertStats: 'Alarm Statistics',
		totalWarnings: 'Total Alarms',
		critical: 'Critical',
		medium: 'Medium',
		normal: 'Normal',
		runOverview: 'Operation Overview',
		startStopRecord: 'Start/Stop Record',
		operationRate: 'Operation Rate',
		totalRunDuration: 'Total Run Duration',
		totalOnlineDuration: 'Total Online Duration',
		hour: 'hours',
		deviceStatus: 'Device Status',
		diagnosticReport: 'Diagnostic Report',
		noDiagnosticReport: 'No Diagnostic Report',
		alarmProcessing: 'Alarm Processing',
		startStopTitle: 'Start/Stop Record',
		status: {
			running: 'Running',
			stopped: 'Stopped',
			offline: 'Offline'
		},
		healthStatus: {
			good: 'Good Health Status',
			medium: 'Medium Health Status',
			poor: 'Poor Health Status'
		},
		healthTip: {
			good: 'Device running well, regular inspection recommended',
			medium: 'Strengthen equipment monitoring and maintenance',
			poor: 'Equipment overhaul needed to prevent failure'
		},
		alertLevel: {
			healthy: 'Equipment Healthy',
			low: 'Low Alarm',
			medium: 'Medium Alarm',
			severe: 'Severe Alarm',
			unknown: 'Unknown Status'
		},
		alertDesc: {
			low: 'Minor abnormality detected, please monitor closely',
			medium: 'Moderate abnormality detected, timely handling recommended',
			severe: 'Severe abnormality detected, immediate action required',
			unknown: 'Equipment status unknown'
		},
		suggestion: 'Suggest monitoring operation',
		alarmBtn: 'Alarm Processing',
		duration: 'Alarm Duration',
		currentDuration: {
			running: 'Current Run Duration',
			stopped: 'Stop Duration',
			offline: 'Offline Duration',
			default: 'Status Duration'
		},
		offlineTotalDuration: 'Total Run Duration (Before Offline)'
	},
	digitalTwin: {
		title: 'Device Digital Twin',
		digitalModeling: 'Digital Modeling',
		realtimeMonitoring: 'Real-time Monitoring',
		monitoringPlaceholder: 'On-site monitoring video is being connected, stay tuned',
		deviceSelectTip: 'Please select a device',
		noDevice: 'No device data',
		modelLoading: 'Model loading...',
		modelLoadFailed: 'Model load failed',
		electrical: {
			title: 'Electrical Parameters',
			inverterParams: 'Inverter Operating Parameters',
			weightInfo: 'Weight Information',
			deviceStatusWord: 'Device Status Word',
			ioStatus: 'Device IO Status',
			faultInfo: 'System Fault Information',
			faultCode: 'Fault Code',
			normal: 'Normal',
			fault: 'Fault',
			bit: 'Bit',
			updateTime: 'Data Update Time',
			mechanism: {
				bridge: 'Bridge',
				trolley: 'Trolley',
				hoist: 'Hoist',
				grab: 'Grab'
			},
			params: {
				outputVoltage: 'Output Voltage',
				outputCurrent: 'Output Current',
				outputTorque: 'Output Torque',
				outputSpeed: 'Output Speed',
				dcBusVoltage: 'DC Bus Voltage',
				actualPosition: 'Actual Position'
			},
			weight: {
				hoist: 'Hoist Weight',
				grab: 'Grab Weight',
				total: 'Total Weight'
			}
		}
	},
	config: {
		gridLayout: 'Grid Layout',
		deviceName: 'Device Name',
		deviceNumber: 'Device Number',
		projectNumber: 'Project Number',
		status: 'Status',
		deviceType: 'Device Type',
		org: 'Organization',
		deviceImage: 'Device Image',
		deviceModelImage: 'Device Model Image',
		sort: 'Sort',
		placeholder: {
			org: 'Organization (Diagnosis)'
		},
		rules: {
			required: 'Required field cannot be empty'
		},
		labels: {
			label1: 'Label 1'
		}
	},
	deviceModelLibrary: {
		configDeviceModel: 'Configure Device Model',
		selectDeviceType: 'Select Device Type',
		deviceModelImageAlt: 'Device Model Image',
		addModelImage: 'Add Model Image',
		messages: {
			pleaseSelectModel: 'Please select a device model image',
			deleteConfirm: 'Are you sure you want to delete this model?',
			deleteConfirmTitle: 'Tip',
			deleteConfirmBtn: 'Confirm',
			deleteCancelBtn: 'Cancel',
			deleteSuccess: 'Deleted successfully',
			operationSuccess: 'Operation successful'
		}
	},
	devicePlm: {
		deviceBasicInfo: 'Device Basic Information',
		editDeviceBasicInfo: 'Edit Device Basic Information',
		fieldName: 'Name',
		fieldValue: 'Value',
		fieldNamePlaceholder: 'Name',
		fieldValuePlaceholder: 'Value',
		healthHistory: 'Health History',
		date: 'Date',
		healthScore: 'Health Score',
		messages: {
			updateSuccess: 'Device information updated successfully',
			updateFailed: 'Device information update failed'
		},
		status: {
			normal: 'Normal',
			abnormal: 'Abnormal',
			warning: 'Warning',
			maintenance: 'Maintenance'
		}
	}
}
